export default __webpack_public_path__ + "static/media/M03.986ab880.svg";